import { MdLocationOn } from "react-icons/md";
import IconItem from "../../../../../components/Atoms/IconItem";
import { EventTracker } from "../../../../Atoms/Analytics";
import BulletList from "../../../../Atoms/BulletList";
import GoogleMapsFrame, {
  generateGoogleMapsUrl,
} from "../../../../Cards/GoogleMapsFrame";
import LazyGoogleMapsFrame from "../../../../Cards/LazyGoogleMapsFrame";
import styles from "./MeetingPlace.module.scss";

function notEmptyLine(text: string) {
  return !!text;
}

function removeHandmadeBulletPoints(text: string) {
  return text.replace(/^- /, "");
}

function toLines(text: string) {
  const lines = text.split(/\n|\r/);

  return lines.filter(notEmptyLine).map(removeHandmadeBulletPoints);
}

export type MeetingPlaceProps = {
  name: string;
  description: string;
  googleMapsUrl: string;
  query?: any;
  showLabel?: boolean;
  // Add the map only when it nears the viewport (see LazyGoogleMapsFrame).
  lazyMap?: boolean;
  withFrame?: boolean;
  showGoogleMapsLink?: boolean;
  showBullets?: boolean;
  classNames?: { name?: string; lines?: string; line?: string };
};

export default function MeetingPlace({
  name,
  description,
  googleMapsUrl,
  query,
  showLabel,
  lazyMap = false,
  withFrame = false,
  showGoogleMapsLink = true,
  showBullets = true,
  classNames,
}: MeetingPlaceProps) {
  const MapsFrame = lazyMap ? LazyGoogleMapsFrame : GoogleMapsFrame;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {showLabel && <p className="DetailTitle">Meeting Point</p>}
      <div
        className={`${styles.MeetingPlaceWrapper} ${
          withFrame ? styles.Framed : ""
        }`}
      >
        <IconItem icon={<MdLocationOn size={24} />}>
          <p className={classNames?.name}>{name}</p>
        </IconItem>
        {query && <MapsFrame query={query} />}
        {showGoogleMapsLink && (
          <EventTracker
            onClick={{
              category: "detail-meeting-place",
              action: "click",
              label: "google-map-link",
            }}
          >
            <a
              style={{ display: "inline-block", marginBottom: 20 }}
              className="ExternalLink"
              href={query ? generateGoogleMapsUrl(query) : googleMapsUrl}
              target="_blank"
              rel="noreferrer"
            >
              See on google maps
            </a>
          </EventTracker>
        )}
        {description && (
          <BulletList
            items={toLines(description)}
            showBullets={showBullets}
            classNames={{ list: classNames?.lines, item: classNames?.line }}
          />
        )}
      </div>
    </div>
  );
}
